module.exports = __webpack_public_path__ + "img/3.71df7883.jpg";